import {Card} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface NewPurchasePriceRuleOptionProps extends TestIdProps {
  title: string;
  description: string;
  isSelected: boolean;
  onSelect: () => void;
  children?: ReactNode;
}

export function NewPurchasePriceRuleOption(props: NewPurchasePriceRuleOptionProps) {
  return (
    <Card
      variant="inlineWhite"
      title={props.title}
      control={{type: 'radio', value: props.isSelected, onChange: props.onSelect}}
      data-testid={props['data-testid']}
    >
      <VStack spacing={2}>
        <Text size="small" color="secondary" data-testid={suffixTestId('description', props)}>
          {props.description}
        </Text>
        {props.children}
      </VStack>
    </Card>
  );
}
